import {
    Typography as MUITypography
} from '@mui/material';
import type {
    SxProps,
    Theme
} from '@mui/material/styles';
import {
    type FC
} from 'react';

import type {
    TypographyProps
} from './types';

import styles from './styles';

const Typography: FC<TypographyProps> = (props) => {
    const {
        sx = [],
        variant = 'body1',
        ...remainingProps
    } = props;

    const variantStyles = styles[variant as keyof typeof styles] ?? styles.body1;

    if (
        process.env.NODE_ENV === 'development'
        && !(variant in styles)
    ) {
        throw new Error(
            `[Typography] Unsupported variant "${variant}". Available variants: ${Object.keys(
                styles
            ).join(', ')}`
        );
    }

    const computedSx = [
        styles.default,
        variantStyles,
        styles.fontFamily,
        ...(Array.isArray(sx) ? sx : [
            sx
        ])
    ].filter(
        (style): style is NonNullable<typeof style> => style !== undefined
    ) as SxProps<Theme>;

    return (
        <MUITypography
            sx={computedSx}
            variant={variant}
            {...remainingProps}
        />
    );
};

export default Typography;
